module.exports = __webpack_public_path__ + "img/video_thumb_intice.c10ad87c.jpg";